import { MemberRequestForm, REQUEST_TYPES, REQUEST_STATUS } from '../model/form.model';

class FormController {

  constructor(MemberRequestApiService, FormService, $window, $timeout) {
    'ngInject';

    this.$window = $window;
    this.$timeout = $timeout;
    this.FormService = FormService;
    this.MemberRequestApiService = MemberRequestApiService;
  }

  $onInit() {
    this.form = new MemberRequestForm();
    this.requestsType = REQUEST_TYPES;
    this.requestStatus = REQUEST_STATUS;
  }

  $doCheck() {
    if (this.form.from && this.form.to) {
      if (this.form.from) {
        this.form.from = moment(this.form.from).format('YYYY-MM-DD');
      }

      if (this.form.to) {
        this.form.to = moment(this.form.to).format('YYYY-MM-DD');
      }
    }
  }

  submit() {
    this.FormService.isSubmitting.next(true);
    this.MemberRequestApiService.getMemberRequests(this.form.toPayload())
    .then((resp) => {
      this.onFiltered({data: resp, total: resp.total, filter: this.form.toPayload()});
    })
    .catch((error) => {
      console.log(error);
    })
    .finally(() => this.FormService.isSubmitting.next(false));
  }

  reset() {
    this.form.reset();
    this.submit();
  }
}

export default FormController;



// WEBPACK FOOTER //
// ./client/app/pages/requests/component/form.controller.js